import React from 'react'
import { IconProps } from '../types'

/**
 * Document icon used for preview card badges.
 */
export default function DocumentIcon({
    className = 'h-[13px] w-[10px]',
    fill = '#0A84FF',
    ...props
}: IconProps) {
    return (
        <svg
            width="10"
            height="13"
            viewBox="0 0 10 13"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={className}
            {...props}
        >
            <path
                d="M1.8165 12.5625H8.039C9.252 12.5625 9.8555 11.9473 9.8555 10.7285V5.40825H5.61325C4.86325 5.40825 4.51175 5.05075 4.51175 4.30075V0H1.8165C0.6095 0 0 0.621 0 1.84V10.7285C0 11.953 0.6095 12.5625 1.8165 12.5625ZM5.631 4.6055H9.791C9.75 4.36525 9.58 4.13075 9.30475 3.84375L6.07025 0.55675C5.80075 0.2755 5.55475 0.1055 5.3085 0.06425V4.28925C5.3085 4.5 5.42 4.6055 5.631 4.6055ZM2.672 7.9455C2.43175 7.9455 2.26175 7.7755 2.26175 7.547C2.26175 7.31825 2.43175 7.1485 2.67175 7.1485H7.18925C7.42375 7.1485 7.6055 7.3185 7.6055 7.54675C7.6055 7.7755 7.42375 7.94525 7.1895 7.94525L2.672 7.9455ZM2.672 10.1777C2.43175 10.1777 2.26175 10.0078 2.26175 9.77925C2.26175 9.55075 2.43175 9.38075 2.67175 9.38075H7.18925C7.42375 9.38075 7.6055 9.55075 7.6055 9.77925C7.6055 10.0078 7.42375 10.1777 7.1895 10.1777H2.672Z"
                fill={fill}
            />
        </svg>
    )
}
